
























































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerInterviewStatus from '@/models/JobWorkerInterviews/JobWorkerInterviewStatus';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import CompleteJobWorkerInterviewRequest from '@/models/JobWorkerInterviews/CompleteJobWorkerInterviewRequest';

@Component({
    name: 'JobWorkerInterviewStatusSetCompleted'
})
export default class extends GiganautVueDialog {
 
  jobWorkerInterviewStatus = JobWorkerInterviewStatus;
  @Prop({required: true})
  jobWorkerInterview: JobWorkerInterviewDto;
  workerFeedback = '';
  contactFeedback = '';

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.workerFeedback = this.jobWorkerInterview.workerFeedback;
      this.contactFeedback = this.jobWorkerInterview.contactFeedback;
    } 
    this.$emit("closeMenu");
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CompleteJobWorkerInterviewRequest();
    request.jobWorkerInterviewId = this.jobWorkerInterview.id;
    request.updatedAt = this.jobWorkerInterview.updatedAt;
    request.workerFeedback = this.workerFeedback;
    request.contactFeedback = this.contactFeedback;

    await JobDetailsModule.completeJobWorkerInterview(request);
    this.dialog = false;
  }
}
